import { useFetch } from '@reveni-io/reveni-ui'

import useNavigateBetweenElements from '@/common/hooks/useNavigateBetweenElements/useNavigateBetweenElements'
import { parcelDirections } from '@/parcels/constants'
import { isInboundParcel } from '@/parcels/helpers/helpers'
import { parcelDirectionConfig } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/constants'
import { getParcelRequestParams } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'
import parcelServices from '@/parcels/services/services'
import { transformResponseParcels } from '@/parcels/transformers/parcels/transformers'
import routes from '@/Router/routes.constants'

const useParcelNavigation = ({ storeId, parcelId, parcel, fetchParcel, info, updateContext }) => {
  const direction = isInboundParcel(parcel) ? parcelDirections.inbound : parcelDirections.outbound
  const { filtersContextKey } = parcelDirectionConfig[direction]

  const { fetchData: getParcels } = useFetch(parcelServices.getParcels, {
    doInitialRequest: false,
    transformResponse: transformResponseParcels,
  })

  const fetchParcels = async ({ storeId, params }) => {
    const parcels = await getParcels({ storeId, params: getParcelRequestParams(params, direction) })

    return { data: parcels }
  }

  const { onNavigateToElementDetail, onGetMoreElements } = useNavigateBetweenElements({
    selectedStoreId: storeId,
    currentId: parcelId,
    fetchDetailElement: fetchParcel,
    elementDetailRoute: routes.parcelDetailPage,
    elementsInContext: info.parcels,
    fetchElements: fetchParcels,
    filtersInContext: info[filtersContextKey],
    nameOfElementsInContext: 'parcels',
    nameOfFiltersInContext: filtersContextKey,
    updateContext,
  })

  return {
    onNavigateToParcelDetail: onNavigateToElementDetail,
    onGetMoreParcels: onGetMoreElements,
  }
}

export default useParcelNavigation
